import React from "react";
import PriceBookBreadCrumb from "../../Components/PriceBook/PriceBookBreadCrumb";
import PriceBookListings from "../../Components/PriceBook/PriceBookListings";

export default function PriceBookListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <PriceBookBreadCrumb />
        <PriceBookListings />
      </div>
    </React.Fragment>
  );
}
